import type { ProductKey } from "@merge-api/merge-javascript-shared";
import submitHubspotForm from "../../../shared/utils/submitHubspotForm";
import { DEFAULT_PRODUCT_FORM_ID, MAX_HUBSPOT_WAIT_MS } from "../constants";

const submitDefaultProductForm = (email: string, product: ProductKey): Promise<void> => {
  return Promise.race([
    submitHubspotForm(DEFAULT_PRODUCT_FORM_ID, [
      { name: "email", value: email },
      { name: "desired_product", value: product },
    ]),
    new Promise<void>((resolve) => {
      window.setTimeout(resolve, MAX_HUBSPOT_WAIT_MS);
    }),
  ]);
};

export default submitDefaultProductForm;
